import parsley from '../../js/parsley.min.js?raw';
import {injectLegacyScripts} from '../shared/inject-legacy-script';
import {initFlexsliderBanner} from '../shared/flexslider-banner';
import {initLegacyTabs} from '../shared/legacy-tabs';
import {ensureMagnificPopupPlugin, initBannerImagePopup} from '../shared/popups';

injectLegacyScripts([
    parsley
]);

ensureMagnificPopupPlugin();

var $ = window.jQuery;

function windowWidth()
{
    var docElemProp = window.document.documentElement.clientWidth;
    var body = window.document.body;

    return window.document.compatMode === 'CSS1Compat' && docElemProp || body && body.clientWidth || docElemProp;
}

function initEnquiryDateButtons()
{
    $(document).on('click', '.enquiryDate', function () {
        var hash = window.location.hash;
        var $form = $('#enquiryModalForm');
        var action = $form.attr('action') || '';

        $('.enquiryTabSection').val(hash);

        if (hash && action.indexOf(hash) === -1) {
            $form.attr('action', action + hash);
        }

        $('#enquiryForm #enquiryModalForm .arrival_date').val($(this).attr('date'));

        if ($.fn.modal) {
            $('#enquiryForm').modal('show');
        }
    });
}

function formatCurrencyAmount(amount)
{
    var digits = String(amount).split('').reverse();
    var output = '';

    for (var index = 0; index <= digits.length - 1; index++) {
        output = digits[index] + output;

        if ((index + 1) % 3 === 0 && (digits.length - 1) !== index) {
            output = ',' + output;
        }
    }

    return output;
}

function installCurrencyUpdate()
{
    window.dt_currency_update = function (userCurrency) {
        var $currency = $('.currency');

        if (!$currency.length) {
            $('.currency_select').val(userCurrency);
            return;
        }

        $.ajax({
            url: '?eID=sb_chalets&tx_sbchalets_pi1[controller]=Ajax&tx_sbchalets_pi1[pluginName]=Pi1&tx_sbchalets_pi1[from]=' + $currency.attr('curr') + '&tx_sbchalets_pi1[to]=' + userCurrency + '&tx_sbchalets_pi1[value]=1',
            dataType: 'html',
            type: 'GET',
            success: function (html) {
                $('.currency').each(function () {
                    var $item = $(this);

                    if ($.trim($item.text()) === 'POA') {
                        return;
                    }

                    var currency = userCurrency;
                    var equal;

                    if (html == 0) {
                        currency = $item.attr('curr');
                        equal = $item.attr('price');
                    } else {
                        equal = Math.round(parseInt($item.attr('price'), 10) * html);
                    }

                    if (isNaN(String(equal))) {
                        $item.html(currency + ' ');
                    } else {
                        $item.html(currency + ' ' + formatCurrencyAmount(equal));
                    }
                });
            }
        });

        $('.currency_select').val(userCurrency);
    };

    window.dt_currency_update('');
}

function initCarouselGallery()
{
    var $gallery = $('.carousel-gallery-popup');

    if (!$gallery.length || !$.fn.magnificPopup) {
        return;
    }

    $gallery.magnificPopup({
        delegate: '.carousel-gallery-link',
        type: 'image',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1]
        },
        image: {
            titleSrc: function (item) {
                return item.el.find('img').attr('alt');
            }
        }
    });
}

function initTabMenuInteractions()
{
    $('body').on('click', '.tx-dftabs-tabMenu a', function () {
        $('.tx-dftabs-tabMenuEntrySelected').removeClass('tx-dftabs-tabMenuEntrySelected');
        $(this).addClass('tx-dftabs-tabMenuEntrySelected');
        $('.tx-dftabs-tabContents').show();
        $('.tx-dftabs-tabContents').next('.appendTo').hide();
    });
}

function installToggleText()
{
    if ($.fn.toggleText) {
        return;
    }

    $.fn.extend({
        toggleText: function (firstText, secondText) {
            var $element = this;

            if ($element.text() !== firstText && $element.text() !== secondText) {
                $element.text(firstText);
            } else if ($element.text() === firstText) {
                $element.text(secondText);
            } else if ($element.text() === secondText) {
                $element.text(firstText);
            }

            return this;
        }
    });
}

function initMobileDetailsToggle()
{
    if (windowWidth() <= 767) {
        setTimeout(function () {
            $('.chaletRightAvailability').html('');
            $('#show_booking_modal_mobile').appendTo('.chaletRightAvailability');
            $('#show_booking_modal_mobile').show();
            $('.tx-dftabs-tabMenu li').hide();

            if (!$('.view_more_details_chalet').length) {
                $('.tx-dftabs-tabMenu').prepend('<li class="tx-dftabs-tabMenuEntry"><a href="#" class="view_more_details_chalet">View more details</a></li>');
            }
        }, 2000);
    }

    $('body').on('click', '.view_more_details_chalet', function (event) {
        event.preventDefault();

        $('.tx-dftabs-tabMenu li').toggle();
        $('.view_more_details_chalet').parent().show();
        $('.view_more_details_chalet').toggleText('View more details', 'Hide details');
    });
}

function initMiscChaletHandlers()
{
    $('.breadcrumb-container .right-content a').on('click', function (event) {
        event.preventDefault();
        $(this).toggleClass('open');
        $('html, body').animate({scrollTop: 0}, 'slow');
        $('.site-search .container').toggleClass('open');
    });

    $('.flexslider a').on('click', function (event) {
        if (!$(event.target).closest('.flex-active-slide').length) {
            return false;
        }
    });

    $('body').on('click', '.currencyLinksxxx a', function () {
        $('.tx-dftabs-tabContents').show();
        $('.tx-dftabs-tabContents').next('.chaletContainer').remove();
        $('.currencyLinks a').eq(0).trigger('click');
    });
}

if ($) {
    $(document).ready(function () {
        initEnquiryDateButtons();
        initLegacyTabs();
        installCurrencyUpdate();
        initCarouselGallery();
        initTabMenuInteractions();
        installToggleText();
        initMobileDetailsToggle();
        initMiscChaletHandlers();
    });

}

initBannerImagePopup();
initFlexsliderBanner('.flexslider');
